<template>
	<div class="sf-datatable-wrapper">
		<div class="sf-datatable-container">
			<div class="sf-card__header mt-3">
				<div class="d-flex align-items-end">
					<!--其他费用明细-->
					<span class="title"><i class="sf-icon icon-sf-caret-right" />{{ getMessage_('QWCC002143') }}</span>
				</div>
			</div>

			<template>
				<sf-data-table
					ref="otherFeeTable"
					:paging="false"
					:columns="otherFeeCols"
					:rows="tableData"
					:excel="false"
					:stripe="false"
					fit
					selection
					height="300px"
				>
					<!--自定义列渲染 开始-->
					<template v-slot:customRows="slotProps">
						<!--费用类型 下拉选择框-->
						<template v-if="slotProps.column.property === 'feeTypeCd'">
							<el-select v-model="slotProps.row.feeTypeCd"  size="small" style="width:100%" :disabled="!roApcnPopUp.btnTsAuth">
								<el-option :label="getMessage_('MWCC000342')" value=""></el-option>
								<el-option
										:key="index"
										v-for="(result, index) in feeTypeList"
										:label="result.commCdName"
										:value="result.commCd"
									></el-option>
							</el-select>
						</template>

						<!--备注-->
						<template v-if="slotProps.column.property === 'remark'">
							<el-input v-model="slotProps.row.remark" maxlength="100" :readonly="!roApcnPopUp.btnTsAuth"/>
						</template>

						<!--单价（元）-->
						<template v-if="slotProps.column.property === 'unitPrice'">
							<el-input :readonly="!roApcnPopUp.btnTsAuth"
								:value="slotProps.row.unitPrice"
								maxlength="16"
								@input="val => onNumberInput(val, slotProps)"
							/>
						</template>

						<!--数量-->
						<template v-if="slotProps.column.property === 'qty'">
							<el-input :readonly="!roApcnPopUp.btnTsAuth"
								:value="slotProps.row.qty"
								maxlength="10"
								@input="val => onNumberInput(val, slotProps)"
							/>
						</template>

						<!--单位-->
						<template v-if="slotProps.column.property === 'feeUnit'">
							<el-input v-model="slotProps.row.feeUnit" maxlength="10" :readonly="!roApcnPopUp.btnTsAuth"/>
						</template>

						<!--总价 = 单价 × 数量（自动计算）-->
						<template v-if="slotProps.column.property === 'totalPrice'">
							{{ calcTotal(slotProps.row) }}
						</template>
					</template>
					<!--自定义列渲染 结束-->

					<!--按钮区域 开始-->
					<template v-slot:actionsRight v-if="roApcnPopUp.btnTsAuth">
						<sf-button size="sm" line icon="square-plue" :onClick="addRow">{{ getMessage_('MWCC000007') }}</sf-button>
						<sf-button size="sm" color="error" line icon="trash" :onClick="deleteRows">{{ getMessage_('MWCC000328') }}</sf-button>
					</template>
					<!--按钮区域 结束-->
				</sf-data-table>
			</template>
		</div>
	</div>
</template>

<script>
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '../../../store/helpers';

export default {
	props: {
		scrId: { type: String, default: '' }
	},
	data() {
		return {
			
		};
	},
	async created() {
		await this.getCommCodes_({ key: 'feeTypeList', codeType: 'APCN_OTHER_FEE' })
	},
	computed: {
		...rootComputed,
		...serviceComputed,
		tableData() {
			//그리드 로우
			return this.roApcnOtherFeeList;
		},
		otherFeeCols() {
			return [
				{
					label: this.getMessage_('SWCC000212'),
					prop: 'sortNo',
					width: '70px',
					align: 'center',
					sortable: false
				},
				{
					label: '* ' + this.getMessage_('QWCC002140'), 
					prop: 'feeTypeCd',
					width: '200px',
					sortable: false,
					custom: true
				},
				{
					label: this.getMessage_('QWCC000906'), 
					prop: 'remark',
					//minWidth: '150px',
					width: '600px',
					sortable: false,
					custom: true
				},
				{
					label: '* ' + this.getMessage_('QWCC002141'), 
					prop: 'unitPrice',
					width: '150px',
					sortable: false,
					custom: true
				},
				{
					label: '* ' + this.getMessage_('QWCC001236'), 
					prop: 'qty',
					width: '150px',
					sortable: false,
					custom: true
				},
				{
					label: '* ' + this.getMessage_('QWCC001124'), 
					prop: 'feeUnit',
					width: '150px',
					sortable: false,
					custom: true
				},
				{
					label: this.getMessage_('QWCC002142'), 
					prop: 'totalPrice',
					minWidth: '150px',
					sortable: false,
					custom: true
				}
			];
		}
	},
	methods: {
		...rootMethods,
		...serviceMethods,
		/**
		 * 计算总价：单价 × 数量，保留两位小数
		 */
		calcTotal(row) {
			const price = parseFloat(row.unitPrice) || 0;
			const qty = parseFloat(row.qty) || 0;
			return Math.round(price * qty * 100) / 100;
		},
		/**
		 * 数字输入处理：仅允许数字和小数点，小数位最多两位（四舍五入）
		 */
		onNumberInput(value, slotProps) {
			const key = slotProps.column.property;
			// 过滤掉除数字和小数点以外的所有字符
			value = value.replace(/[^\.0-9]/g, '');
			// 找到第一个小数点，移除多余小数点，小数位截断至2位
			const dotIndex = value.indexOf('.');
			if (dotIndex !== -1) {
				const intPart = value.slice(0, dotIndex + 1);
				const decPart = value.slice(dotIndex + 1).replace(/\./g, '').slice(0, 2);
				value = intPart + decPart;
			}
			slotProps.row[key] = value;
		},
		/**
		 * 添加行：序号自动累加
		 */
		addRow() {
			const newRow = {
				sortNo: this.tableData.length + 1,
				feeType: '',
				remark: '',
				unitPrice: '',
				qty: '',
				feeUnit: 'EA',
				totalPrice: ''
			};
			this.tableData.push(newRow);
		},
		/**
		 * 删除行：校验是否已勾选，未勾选给出提示；删除后序号自动更新
		 */
		deleteRows() {
			const selectedRows = this.$refs.otherFeeTable.getSelectedRows();
			if (selectedRows.length < 1) {
				this.$sf_showMessage({
					icon: 'error',
					title: this.getMessage_('MWCC000109'),
					message: this.getMessage_('MWCC000110')
				});
				return;
			}
			const filtered = this.tableData.filter(row => !selectedRows.includes(row));
			filtered.forEach((row, index) => {
				row.sortNo = index + 1;
			});
			this.setState_({ key: 'roApcnOtherFeeList', value: filtered });
		},
		/**
		 * 对外暴露：获取当前列表数据（供父组件保存时调用）
		 */
		getTableData() {
			return this.tableData;
		}
	}
};
</script>
